export const firstLetter = (name) => {
  return name ? name[0] + "." : ""
};

export const completePilotName = (pilot) => {
  if (!pilot) return "Není";
  return (pilot.name ? pilot.name : "") +  (pilot.surname ? " " +pilot.surname : "");
}